import { ChangeEvent, CSSProperties } from 'react';

import { SYMBOLS } from '../utils/constants';

import styles from './DraggableInput.module.scss';

interface IDraggableInput {
  value?: number;
  minValue?: number;
  maxValue?: number;
  containerProperties?: CSSProperties;
  onChange?: (value: number) => void;
}

export const DraggableInput = ({
  value = 0,
  minValue = 0,
  maxValue = 100,
  containerProperties,
  onChange,
}: IDraggableInput) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(event.target.value);
    onChange && onChange(newValue);
  };

  return (
    <div className={styles.draggable} style={containerProperties}>
      <span className={styles.draggable__symbols}>{SYMBOLS.MINUS}</span>
      <input
        type='range'
        min={minValue}
        max={maxValue}
        step={0.01}
        value={value}
        onChange={handleChange}
        className={styles.draggable__input}
      />
      <span className={styles.draggable__symbols}>{SYMBOLS.PLUS}</span>
    </div>
  );
};
